import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const INITIAL_STATE = {
	changeOfAddress: false,
	changeOfVehicle: false,
	changeOfDriver: false,
	changeOfUsage: false,
	changeOfExcess: false,
};

const renewalChanges = createSlice({
	name: 'renewalChanges',
	initialState: INITIAL_STATE,
	reducers: {
		updateChangeOfAddress: (state, action: PayloadAction<boolean>) => {
			state.changeOfAddress = action.payload;
		},
		updateChangeOfVehicle: (state, action: PayloadAction<boolean>) => {
			state.changeOfVehicle = action.payload;
		},
		updateChangeOfDriver: (state, action: PayloadAction<boolean>) => {
			state.changeOfDriver = action.payload;
		},
		updateChangeOfUsage: (state, action: PayloadAction<boolean>) => {
			state.changeOfUsage = action.payload;
		},
		updateChangeOfExcess: (state, action: PayloadAction<boolean>) => {
			state.changeOfExcess = action.payload;
		},
		resetRenewalChanges: () => INITIAL_STATE,
	},
});

export const {
	updateChangeOfAddress,
	updateChangeOfVehicle,
	updateChangeOfDriver,
	updateChangeOfUsage,
	updateChangeOfExcess,
	resetRenewalChanges,
} = renewalChanges.actions;

export default renewalChanges.reducer;
